import { apiClient } from '../config';

// Fetch service page data from /items/service_page
export const fetchServicePage = async () => {
  try {
    console.log(`Fetching service page from /items/service_page`);
    const response = await apiClient.get('/items/service_page');
    console.log('Service page response:', response.data);
    return response.data.data || null;
  } catch (error) {
    console.error('Error fetching service page:', error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

